import React, { Component } from 'react';
import { CircularProgress } from 'material-ui-beta/Progress';
import Card from 'material-ui-beta/Card';
import Button from 'material-ui-beta/Button';
import Divider from 'material-ui-beta/Divider';
import IconButton from 'material-ui-beta/IconButton';
import numeral from 'numeral';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogTitle,
} from 'material-ui-beta/Dialog';
import Slide from 'material-ui-beta/transitions/Slide';
import Checkbox from 'material-ui-beta/Checkbox';

import api from '../../api/api';
import ShoppingCartItem from '../../models/ShoppingCartItem';

import infoIcon from '../../img/ic_info_outline_black_24px.svg';
import downloadIcon from '../../img/ic_file_download_white_24px.svg';
import './AdminMemberResources.css';

const ZonedDateTime = require('js-joda').ZonedDateTime;

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class AdminMemberResources extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            admin_resources: null,
            member_resources: null,
            org_locations: null,
            selected_member_resource: null,
            selected_pricing_option: null,
            activePurchases: null
        };
    }

    componentDidMount() {
        this.fetchAdminResources();
        this.fetchActivePurchases();
    }

    fetchAdminResources() {
        api.getAdminResources().then(resources => {
            this.fetchMemberResources(resources);
        }).catch(err => {
            console.log(err);
            alert('Error fetching admin resources');
        })
    }

    fetchMemberResources(admin_resources) {
        api.getMemberResources().then(resources => {
            this.setState({
                loading: false,
                admin_resources: admin_resources,
                member_resources: resources
            });
            this.fetchOrgLocations();
        }).catch(err => {
            console.log(err);
            alert('Error fetching admin resources');
        })
    }

    fetchOrgLocations() {
        api.locationsForOrgId(this.props.user.orgId, (locations) => {
            console.log("org locations", locations);
            this.setState({
                org_locations: locations
            });
        })
    }

    fetchActivePurchases() {
        api.watchActivePurchases(this.props.user, activePurchases => {
            this.setState({
                activePurchases: activePurchases.val() || {}
            });
        })
    }

    isUserAdmin() {
        return this.props.user && this.props.user.isAdmin;
    }

    getAdminResources() {
        if (this.state.admin_resources) {
            return this.state.member_resources.concat(this.state.admin_resources);
        }
        return [];
    }

    onPriceOptionClick = (resource, optionIndex) => {
        console.log("onPriceOptionClick", resource, optionIndex);
        if (resource.per_location) {
            this.setState({
                selected_member_resource: resource,
                selected_pricing_option: optionIndex
            });
        } else {
            this.props.onAddItemToCart(new ShoppingCartItem(this.props.user.isPreferred, resource, optionIndex, null));
        }
    }

    handleClose = () => {
        this.setState({
            selected_member_resource: null,
            selected_pricing_option: null
        });
    }

    getSelectedPricingOption() {
        if (this.state.selected_member_resource) {
            return this.state.selected_member_resource.pricing[this.state.selected_pricing_option];
        }
        return null;
    }

    onAddPerLocationOptionToCart = (locations) => {
        this.props.onAddItemToCart(new ShoppingCartItem(this.props.user.isPreferred, this.state.selected_member_resource, this.state.selected_pricing_option, locations));
        // this.props.onAddItemToCart({
        //     resource: this.state.selected_member_resource,
        //     selectedOption: this.state.selected_pricing_option,
        //     locations: locations,
        //     totals: totals
        // });
    };

    render() {
        return (
            <div className="admin-member-resources-container flex">
                <div className="flex flex1 justifyCenter">
                    {this.state.loading ?
                        <CircularProgress size={50}/>
                        :
                        <div className="flex column flex1">
                            {this.getAdminResources().map((resource, index) => {
                                return (
                                    <AdminMemberResource
                                        key={"admin-resource-" + index}
                                        resource={resource}
                                        index={index}
                                        user={this.props.user}
                                        onPriceOptionClick={this.onPriceOptionClick}
                                        activePurchases={this.state.activePurchases} />
                                )
                            })}
                        </div>
                    }
                </div>
                <ChooseLocationDialog
                    open={this.state.selected_member_resource !== null}
                    locations={this.state.org_locations}
                    priceOption={this.getSelectedPricingOption()}
                    user={this.props.user}
                    handleClose={this.handleClose}
                    onAddToCart={this.onAddPerLocationOptionToCart} />
            </div>
        )
    }

}


class AdminMemberResource extends Component {

    getPricingOptions() {
        return this.props.resource.pricing || [];
    }

    render() {
        return (
            <div className="admin-member-resource-container flex1">
                <Card className="admin-member-resource-card">
                    <div className="admin-member-resource-card-top oswald">
                        <div>
                            {this.props.resource.title}
                        </div>
                        <div className="admin-member-resource-card-top-description lato">
                            {this.props.resource.description}
                        </div>
                    </div>
                    <div className="admin-member-resource-card-content">
                        {this.props.activePurchases ?
                            <AdminMemberResourceInfo
                                {...this.props}
                                activePurchases={this.props.activePurchases} />
                            :
                            <CircularProgress size={45} />
                        }
                    </div>
                    <Divider />
                    <div className="admin-member-resource-card-prices">
                        {this.getPricingOptions().map((priceOption, index) => {
                            return (
                                <div key={"price-option-" + index}>
                                    <AdminMemberResourcePricingOption
                                        priceOption={priceOption}
                                        index={index}
                                        user={this.props.user}
                                        onPriceOptionClick={this.props.onPriceOptionClick.bind(null, this.props.resource, index)} />
                                    {index < this.getPricingOptions().length - 1 ?
                                        <Divider />
                                        :
                                        null
                                    }
                                </div>
                            )
                        })}
                    </div>
                </Card>
            </div>
        )
    }
}

class AdminMemberResourceInfo extends Component {

    getActivePurchaseForResource() {
        return this.props.activePurchases[this.props.resource.id];
    }

    getContent() {
        let activePurchase = this.getActivePurchaseForResource();
        console.log('active purchase', activePurchase);
        if (activePurchase !== undefined) {
            if (activePurchase.locations) {
                var locations = [];
                for (var attribute in activePurchase.locations) {
                    locations.push(activePurchase.locations[attribute]);
                }
                return <AdminMemberResourcePerLocationInfo
                    {...this.props}
                    activePurchase={activePurchase}
                    locations={locations} />
            }
            return <AdminMemberResourceDownloadInfo
                {...this.props}
                activePurchase={activePurchase} />
        }
        return null;
    }

    render() {
        return (
            <div>
                {this.getContent()}
            </div>
        )
    }

}

class AdminMemberResourcePerLocationInfo extends Component {

    isSponsoredLocations() {
        return this.props.resource.id === "sponsored_search_results";
    }

    getTitleText() {
        return this.isSponsoredLocations() ? "Currently Sponsored Locations:" : "Locations Receiving Reports:";
    }

    getCreditsLeftText(purchase, location) {
        if (this.isSponsoredLocations()) {
            let date = ZonedDateTime.parse(purchase.purchaseDate);
            date = date.plusMonths(parseInt(location.credits, 10));
            return `Expires ${date.month().value()}/${date.dayOfMonth()}/${date.year()}`;
        }
        return `${location.credits} Report(s) Remaining`;
    }

    render() {
        return (
            <div className="padding30">
                <div className="admin-member-resource-info-title oswald">
                    {this.getTitleText()}
                </div>
                <div className="marginTop15">
                    {this.props.locations.map((location, j) => {
                        return (
                            <div key={this.props.activePurchase.purchaseId + "location-" + j} className="flex">
                                <div className="admin-member-resource-info-location-name lato flex1">
                                    - {location.name}
                                </div>
                                <div className="admin-member-resource-info-expires lato">
                                    {this.getCreditsLeftText(this.props.activePurchase, location)}
                                </div>
                            </div>
                        )
                    })}
                </div>

            </div>
        )
    }

}

class AdminMemberResourceDownloadInfo extends Component {

    onDownloadClick = () => {
        window.open(this.props.resource.downloadUrl);
    }

    getNumReportsLeft() {
        // let num = 0;
        // this.props.activePurchase.forEach(purchase => {
        //     num += purchase.credits;
        // });
        // return num;
        return this.props.activePurchase.credits;
    }

    render() {
        return (
            <div className="padding30 flex">
                <div className="flex1">
                    <Button variant="raised" color="primary" className="admin-member-resource-download-button" onClick={this.onDownloadClick}><img src={downloadIcon} alt="download"/>Download</Button>
                </div>
                <div className="admin-member-resource-info-expires lato flex centerBoth">
                    {`${this.getNumReportsLeft()} Report(s) Remaining`}
                </div>
            </div>
        )
    }

}

class AdminMemberResourcePricingOption extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showInfo: false
        };
    }

    onInfoClick = (event) => {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();

        this.setState({
            showInfo: true
        });
    };

    handleClose = () => {
        this.setState({
            showInfo: false
        });
    };

    onGoToWebClick = () => {
        window.open("https://infusioncenter.org/membership/");
        this.handleClose();
    };

    render() {
        return (
            <div className="flex admin-member-resource-price-container" onClick={this.props.onPriceOptionClick}>
                <div className="flex flex1 lato admin-member-resource-price-title alignCenter">
                    {this.props.priceOption.title}
                </div>
                <div className="flex lato admin-member-resource-price-amounts">
                    {!this.props.user.isPreferred ?
                        <div>
                            <div className="alignRight admin-member-resource-price-amounts-price marginTop10">
                                {numeral(this.props.priceOption.price / 100.0).format('$0,0.00')}
                            </div>
                            <div className="flex admin-member-resource-price-amounts-member-price-container">
                                <div className="flex centerBoth">
                                    <IconButton onClick={this.onInfoClick}><img src={infoIcon} className="admin-member-resource-price-info-img" alt="info" /></IconButton>
                                </div>
                                <div className="flex centerBoth admin-member-resource-price-amounts-member-price">
                                    Member Price&nbsp;&nbsp;{numeral(this.props.priceOption.member_price / 100.0).format('$0,0.00')}
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className="flex justifyEnd admin-member-resource-price-amounts-member-price marginTop15">
                                <strike>Non Member Price {numeral(this.props.priceOption.price / 100.0).format('$0,0.00')}</strike>
                            </div>
                            <div className="alignRight admin-member-resource-price-amounts-price admin-member-resource-price-amounts-price-member marginBottom15">
                                <span className="admin-member-resource-price-amounts-price-member-label">Member Price</span> {numeral(this.props.priceOption.member_price / 100.0).format('$0,0.00')}
                            </div>
                        </div>
                    }
                </div>
                <Dialog
                    open={this.state.showInfo}
                    transition={Transition}
                    onClose={this.handleClose}>
                    <DialogTitle id="alert-dialog-slide-title">
                        <div className="flex1 oswald admin-member-resource-dialog-title">
                            Member Pricing
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div>
                            We provide discounts to members within our Provider Membership structure to ensure they have as many resources as possible to provide exemplary care for their patients.
                        </div>
                        <div className="marginTop15">
                            For more information visit our website.
                        </div>
                        <div className="marginTop20 flex center">
                            <Button variant="raised" color="primary" className="admin-member-resource-website-button" onClick={this.onGoToWebClick}>Go to Website</Button>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">OK</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }

}

class ChooseLocationDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedIndices: []
        }
    }

    getNumSelectedLocations() {
        return this.state.selectedIndices.length;
    }

    getLocationAddress(location) {
        console.log(location);
        return `${location.address1} ${location.city}, ${location.stateAbbr} ${location.postCode}`;
    }

    isLocationChecked = (index) => {
        return this.state.selectedIndices.includes(index);
    };

    onLocationSelected = (index) => {
        let selectedIndices = [].concat(this.state.selectedIndices);
        let indexAt = this.state.selectedIndices.indexOf(index);
        if (indexAt > -1) {
            selectedIndices.splice(indexAt, 1);
        } else {
            selectedIndices.push(index);
        }
        this.setState({
            selectedIndices: selectedIndices
        });
    };

    onSelectAllClick = () => {
        let indices = [];
        this.props.locations.forEach((location, index) => {
            indices.push(index);
        });
        this.setState({
            selectedIndices: indices
        });
    };

    calculateTotal = () => {
        if (this.props.priceOption) {
            let price = this.props.user.isPreferred ? this.props.priceOption.member_price : this.props.priceOption.price;
            return this.getNumSelectedLocations() * price;
        }
        return 0;
    };

    handleClose = () => {
        this.setState({
            selectedIndices: []
        });
        this.props.handleClose();
    };

    onAddToCart = () => {
        if (this.state.selectedIndices.length) {
            let locations = [];
            this.state.selectedIndices.forEach(index => {
                locations.push(this.props.locations[index]);
            });
            this.props.onAddToCart(locations)
        }
        this.handleClose();
    };

    render() {
        return (
            <Dialog
                open={this.props.open}
                transition={Transition}
                onClose={this.handleClose}>
                <DialogTitle id="alert-dialog-slide-title">
                    <div className="flex admin-member-resource-dialog-title-container">
                        <div className="flex1">
                            <Button color="primary" onClick={this.onSelectAllClick}>Select All</Button>
                        </div>
                        <div className="flex1 oswald admin-member-resource-dialog-title">
                            Choose Locations
                        </div>
                        <div className="flex1 lato admin-member-resource-dialog-locations-selected">
                            {`${this.getNumSelectedLocations()} Locations Selected`}
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent>
                    {this.props.locations ?
                        this.props.locations.length ?
                            this.props.locations.map((location, index) => {
                                return (
                                    <div key={"location-" + index}>
                                        <div className="flex" onClick={this.onLocationSelected.bind(null, index)}>
                                            <div className="admin-member-resource-dialog-location-container flex1">
                                                <div className="admin-member-resource-dialog-location-name oswald">
                                                    {location.name}
                                                </div>
                                                <div className="admin-member-resource-dialog-location-address lato">
                                                    {this.getLocationAddress(location)}
                                                </div>
                                            </div>
                                            <div className="flex centerBoth">
                                                <Checkbox
                                                    checked={this.isLocationChecked(index)}
                                                    onChange={this.onLocationSelected.bind(null, index)}
                                                    value="checked" />
                                            </div>
                                        </div>
                                        <Divider />
                                    </div>
                                )
                            })
                            :
                            <div className="admin-member-resource-dialog-location-name oswald">
                                No locations. Add one in the Location Manager.
                            </div>
                        :
                        <div className="flex centerBoth">
                            <CircularProgress size={50} />
                        </div>
                    }
                </DialogContent>
                <DialogActions>
                    <div>
                        <div className="alignRight">
                            <div className="admin-member-resource-dialog-total oswald">
                                Total
                            </div>
                            <div className="admin-member-resource-dialog-total-amount lato">
                                {numeral(this.calculateTotal() / 100.0).format('$0,0.00')}
                            </div>
                        </div>
                        <div className="flex">
                            <Button onClick={this.handleClose} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={this.onAddToCart} color="primary">
                                Add To Cart
                            </Button>
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
        )
    }

}

export default AdminMemberResources;


// WEBPACK FOOTER //
// ./src/components/admin-member-resources/AdminMemberResources.js